import type { PayTier } from './tier-content';

/** URL canônica do checkout novo (host pay, path curto). */
export function payUrlFor(
  tier: PayTier,
  base: string = process.env['NEXT_PUBLIC_PAY_URL'] ?? 'https://pay.trakd.pro',
): string {
  return `${base.replace(/\/$/, '')}/${tier}`;
}

/** Rollback operacional (spec §7): flag volta os CTAs pro Stripe Checkout hosted. */
export function useHostedFallback(): boolean {
  return process.env['NEXT_PUBLIC_CHECKOUT_FALLBACK_HOSTED'] === '1';
}
